export default "__VITE_ASSET__pSZ5yYLf__"